import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Paper, Grid, List, ListItem, ListItemIcon, ListItemText, Checkbox, Typography, Divider, Stack, TextField, MenuItem } from "@material-ui/core";
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack5';
import apiTeam from '../../../api/team';
import apiContact from '../../../api/contact';
import apiUser from '../../../api/user';
import useAuth from "../../../hooks/useAuth";
import { objectID } from "../../../utils/objectID";

export default function DialogChangeAssigner({ isOpenDialogChangeAssigner, onClose, contactSelected, setIsRefreshContact,paramSearch }) {
    const [departments, setDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [departmentSelected, setDepartmentSelected] = useState(null);
    const [userSelected, setUserSelected] = useState(null);
    const [typeImport, setTypeImport] = useState("default");
    const { user } = useAuth();
    const { enqueueSnackbar } = useSnackbar();
    const onChangeDepartment = (e) => {
        const load_user = async (param) => {
            const res_users = await apiUser.view(param);
            setUsers(res_users.data.data);

        }
        load_user({ department_id: e.target.value });
        setDepartmentSelected(e.target.value)
    }
    useEffect(() => {
        const loadDepartment = async () => {
            const res_teams = await apiTeam.listDepartment({})
            setDepartments(res_teams.data.data);
        }
        loadDepartment()
    }, []);
    const onChangeAssignedBy = async (e) => {
        setUserSelected(e.target.value)

    }
    const saveChangeTrasferContact = async () => {
        try {
            const res_transfer_contact = await apiContact.saveChangeTransferContact({ contactSelected, departmentSelected, userSelected ,typeImport,paramSearch });
            enqueueSnackbar("Chuyển đổi thành công", { variant: 'success' });
            setIsRefreshContact(true);
            onClose();
        } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }
    }
    const onChangeTypeImport = async (e) => {
        setTypeImport(e.target.value)
    }
    return (

        <Dialog open={isOpenDialogChangeAssigner} onClose={onClose} fullWidth>
            {/* <DialogTitle>Gửi tin nhắn cho {contact.name}</DialogTitle> */}
            <DialogTitle>
                <Typography sx={{ color: '#303187', fontSize: '20px', fontWeight: 700 }}> Chuyển đổi danh bạ</Typography>
            </DialogTitle>
            <Divider sx={{ mt: '20px' }} />
            <DialogContent>
                <Stack direction={"column"} sx={{ py: 1 }} spacing={2} >
                    <Stack direction={"row"} spacing={2} >
                        <TextField
                            select
                            fullWidth
                            label={"Phòng ban phụ trách"}
                            placeholder={"Phòng ban"}
                            name="department_id"
                            onChange={e => onChangeDepartment(e)}

                        >
                            <MenuItem value="">Chọn phòng ban</MenuItem>
                            <MenuItem value="Admin">Admin</MenuItem>
                            {departments.map((department, index) => {
                                return (<MenuItem value={objectID(department._id)}>{department.name}</MenuItem>);
                            })}
                        </TextField>
                        <TextField
                            select
                            fullWidth
                            label="Người phụ trách"
                            placeholder={"Người phụ trách"}
                            name="assigned_by"
                            onChange={e => onChangeAssignedBy(e)}
                        >
                            <MenuItem value={user.id}>{"Tôi"}</MenuItem>
                            {users && users.map((item, index) => {
                                return (<MenuItem key={index} value={objectID(item._id)}>{item.full_name}</MenuItem>);
                            })}
                        </TextField>

                    </Stack>
                    <TextField
                        select
                        fullWidth
                        label="Loại chuyển danh bạ"
                        placeholder="Loại chuyển danh bạ"
                        name="type_import"
                        defaultValue={typeImport}
                        onChange={e => onChangeTypeImport(e)}
                    >
                        <MenuItem value="default">Chuyển theo danh sách đã chọn</MenuItem>
                        <MenuItem value="filter">Chuyển theo bộ lọc</MenuItem>

                    </TextField>
                </Stack>
                {/* <Grid container spacing={2} justifyContent="center" alignItems="center">
              
                </Grid> */}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => saveChangeTrasferContact()} variant="contained" color="primary">
                    Xác nhận
                </Button>
                <Button onClick={() => onClose()} variant="contained" color="primary">
                    Hủy bỏ
                </Button>

            </DialogActions>
            <Box sx={{ width: "100%" }}>
                <Box sx={{ height: "15px", width: '75%', float: "right", background: "#41c7f5", clipPath: 'polygon(0 0, 100% 0, 100% 100%, 5% 100%)' }}> </Box>
                <Box sx={{ height: "15px", width: '40%', background: "red", clipPath: 'polygon(0 0, 93% 0, 100% 100%, 0 100%)' }}> </Box>
            </Box>
        </Dialog>

    );
}
